export const MOBILE_SMALL_WIDTH = 320;
export const MOBILE_MEDIUM_WIDTH = 414;
export const MOBILE_LARGE_WIDTH = 768;
export const DESKTOP_SMALL_WIDTH = 1020;
export const DESKTOP_MEDIUM_WIDTH = 1510;
export const DESKTOP_LARGE_WIDTH = 1980;
export const DESKTOP_EXTRA_LARGE_WIDTH = 2560;
